import { richTextToPlain } from "./rich-text/richText";
import { BiLinkExternal } from "react-icons/bi";

const ReplaceAsTaskNotification = ({ content, trigger }) => {
  // Updated regex to handle all three ticket types dynamically
  const taskRegex =
    /\[\[You have been assigned a new (Internal Task|Scrum Ticket|Support Ticket) ticket: ([\s\S]+?) : (\d+)\]\]/g;

  const handleTaskClick = (taskId, ticketType) => {
    if (taskId) {
      trigger(taskId, ticketType); // Pass both taskId and ticketType
    }
  };

  const processString = (str) => {
    if (typeof str !== "string") return str;

    const parts = [];
    let lastIndex = 0;
    let match;
    const regex = new RegExp(taskRegex);

    try {
      while ((match = regex.exec(str)) !== null) {
        if (!match || match.length < 4) {
          lastIndex = regex.lastIndex;
          continue;
        }

        if (match.index > lastIndex) {
          parts.push(str.substring(lastIndex, match.index));
        }

        const ticketType = match[1]; // "Internal Task", "Scrum Tickets", or "Support Tickets"
        const taskName = richTextToPlain(match[2] || "").trim() || "Unknown Task";
        const taskId = match[3];

        if (taskId) {
          parts.push(
            <span
              key={`${ticketType}-${taskId}-${lastIndex}`}
              onClick={() => handleTaskClick(taskId, ticketType)}
              className="text-blue-400 hover:text-blue-300 underline inline-flex items-center gap-0.5 transition-colors cursor-pointer"
            >
              You have been assigned a new {ticketType} ticket: {taskName} :{" "}
              {taskId}
              <BiLinkExternal className="text-xs" />
            </span>
          );
        } else {
          parts.push(match[0]);
        }

        lastIndex = regex.lastIndex;
      }
    } catch (e) {
      console.error("Regex processing error:", e);
      return str;
    }

    if (lastIndex < str.length) {
      parts.push(str.substring(lastIndex));
    }

    return parts.length > 0 ? parts : str;
  };

  try {
    if (Array.isArray(content)) {
      return content.map((part, index) =>
        typeof part === "string" ? processString(part) : part
      );
    } else if (typeof content === "string") {
      return processString(content);
    }
    return content;
  } catch (e) {
    console.error("Content processing error:", e);
    return content;
  }
};

export default ReplaceAsTaskNotification;
